module.exports = __webpack_public_path__ + "img/r-153.01fa0bfe.jpg";